import '../css'
import URI from 'urijs'

const applyScopes = function() {
  const uri = new URI()
  uri.removeQuery(/.*/)
  document.querySelectorAll('.scope').forEach(el => uri.setQuery(el.name, el.value))
  window.location.href = uri.normalizeQuery().toString()
}

$(document).on('change', 'select.scope', applyScopes)

addEventListener('keyup', e => {
  if (e.target.matches('input[type="text"].scope') && e.key == 'Enter') {
    e.preventDefault()
    applyScopes()
  }
})

addEventListener('change', ({ target }) => {
  const form = target.closest('form.registration-form')
  if (form) {
    fetch(form.action, {
      method: 'PATCH',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then(resp => {
        if (resp.ok) return resp.text()
      })
      .then(text => {
        document.getElementById('content').innerHTML = text
        $('select.select2').select2()
      })
  }
})

addEventListener('submit', e => {
  if (e.target.matches('#new-registration-lookup')) {
    e.preventDefault()

    const results = document.querySelector('#lookup-results')
    results.innerHTML = '<i class="fa fa-spinner fa-spin fa-5x">'

    const { action, method } = e.target

    fetch(action, { method, body: new FormData(e.target) })
      .then(resp => {
        if (resp.ok) return resp.text()
      })
      .then(text => { results.innerHTML = text })
  }
})

addEventListener('click', ({ target }) => {
  const td = target.closest('td.flag')

  if (td) {
    fetch(td.querySelector('span[data-url]').dataset.url, {
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      method: 'PATCH'
    })
      .then(resp => {
        if (resp.ok) return resp.text()
      })
      .then(text => { td.innerHTML = text })
  }
})
